import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DependentDropdown from '@features/crm/components/DependentDropdown';
import { generateCRMDashboardParams } from '@features/filter/static/filterUtil';
import DateRangeRightSidePanel from '@features/filter/v2/salesFunnel/DateRangeRightSidePanel';

import { clearGlobalFilterWithDateField, storeSelectedFilterCheckboxType } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getCRMDashboardFilterOptions } from '@services/crmService';

import { crmDateRangePresets, isAccountManager, isCRMManagement, isDirector } from '@utils/Util';

const DashboardFilter = ({ isIndividualUser }) => {
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [filterOptions, setFilterOptions] = useState({});
	const dispatch = useDispatch();

	const generateParams = () => {
		return {
			...generateCRMDashboardParams(filterFields)
		};
	};

	useEffect(() => {
		(async () => {
			try {
				dispatch(openLoader());
				const data = await getCRMDashboardFilterOptions(generateParams());
				let countryList = data?.countryList?.map((item) => ({
					id: item.id,
					value: item.name
				}));
				setFilterOptions({
					brands: data?.brandList?.map((item) => ({ id: item.id, value: item.name })),
					accountManagers: data?.accountManagerList?.map((item) => ({
						id: item.id,
						value: item.name
					})),
					countryList: [
						{
							id: null,
							value: 'Global'
						}
					].concat(countryList)
				});
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, [filterFields]);

	const getSelectedYearPreset = () => {
		let selected = {};
		if (filterFields?.dateRange?.[0]?.key) {
			selected = crmDateRangePresets.find(
				(item) => item.id === filterFields?.dateRange?.[0]?.additionalData
			);
		}
		return selected?.label || 'Date Range';
	};
	const clearDate = () => {
		dispatch(clearGlobalFilterWithDateField());
	};
	return (
		<>
			{isCRMManagement() && (
				<div className="single-filter">
					<DependentDropdown
						placeholder={'Global'}
						options={filterOptions.countryList}
						identifier={'countryIds'}
						multiple={true}
					/>
				</div>
			)}
			<div className="common-date-filter-on-topbar">
				<button
					className="button text-only d-flex align-items-center mx-3"
					onClick={() => dispatch(storeSelectedFilterCheckboxType('DATE_RANGE'))}
				>
					<img
						src={`${process.env.PUBLIC_URL}/icons/calendar-thin.svg`}
						alt="calender"
						className="mr-2"
					/>
					<p className="regular-14 ">{getSelectedYearPreset()}</p>
				</button>

				<DateRangeRightSidePanel
					type={'DATE_RANGE'}
					presets={crmDateRangePresets}
					clearDate={clearDate}
				/>
			</div>
			<div className="single-filter">
				<DependentDropdown
					placeholder={'Brand'}
					options={filterOptions.brands}
					identifier={'brandIds'}
					multiple={true}
				/>
			</div>
			{!isIndividualUser && (isCRMManagement() || isAccountManager() || isDirector()) && (
				<div className="single-filter">
					<DependentDropdown
						placeholder={'Account Manager'}
						options={filterOptions.accountManagers}
						identifier={'accountManagerIds'}
						multiple={true}
					/>
				</div>
			)}
		</>
	);
};

export default DashboardFilter;
